import * as React from 'react';
import cx from 'classnames';
import { currency, date, timeStamp } from '~/lib/formatters';
import PageContentWrapper from '~/common/layout/PageContentWrapper';
import Table from '~/common/components/Table';
import {
  getPaymentName,
  getSaleStatusName,
  isSaleDeletable,
  isSaleEditable,
  SaleStatus
} from '~/apps/pos/shared/services/helpers';
import DropDownButtons from "~/common/controls/DropDownButtons";
import { getCompanyFieldLabel, getSaleNumber } from "~/apps/pos/helpers";
import { Features } from "~/apps/shared/consts";
import TableSlicedString from "~/common/components/TableSlicedString";

export default (props) => {
  const { onEdit, onView, onDelete, filter, additionalFields, features, ...rest } = props;

  const handleOnEdit = (model) => {
    onEdit(model.id);
  };

  const handleOnDelete = (model) => {
    onDelete(model.id, filter);
  };

  const handleOnView = (model) => {
    onView(model.id, filter);
  };

  const getStatusClasses = (status) => {
    return cx('btn btn--sm', {
      'btn--prim': status === SaleStatus.COMPLETED.key,
      'btn--warn': status === SaleStatus.PAYMENT_FAILED.key,
      'btn--lgry': status === SaleStatus.NEW.key,
      'btn--yell': status === SaleStatus.PAYMENT_PROCESSING.key,
    });
  };

  let columnsFirst: any = [
    {
      Header: 'Sale #',
      id: 'number',
      accessor: s => getSaleNumber(s, features),
    },
    {
      Header: 'Date',
      id: 'date',
      accessor: d => timeStamp(d.createdAt),
    },
    {
      Header: 'Amount',
      id: 'price',
      accessor: c => currency(c.price),
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: s => {
        return(<span className={getStatusClasses(s.status)} style={{ 'cursor': 'default' }}>{getSaleStatusName(s.status)}</span>);
      },
      width: 140,
    },
    {
      Header: 'Payment',
      id: 'paymentType',
      accessor: p => getPaymentName(p.paymentType),
    },
  ];

  if (!features.includes(Features.PO_NUMBER_NOT_REQUIRED)) {
    columnsFirst.push({
      Header: 'PO #',
      accessor: 'poNumber',
    });
  }

  columnsFirst.push({
    Header: getCompanyFieldLabel(features),
    accessor: 'company',
  });

  if (features.includes(Features.ENABLE_NOT_FIELD_FOR_CLERKS)) {
    columnsFirst.push({
      Header: 'Note',
      id: 'description',
      accessor: d => <TableSlicedString value={d.description} />,
    })
  }

  let columnAdditional: any = [];
  additionalFields.forEach((a) => {
      const additional = a.additionalFields;

      if (a.showInTable) {
        columnAdditional.push({
          Header: a.name,
          id: a.id,
          accessor: (d) => {
            return d.additionalFields && d.additionalFields[a.name];
          }
        })
      }
    }
  );

  if (features.includes(Features.ADD_COMPLETED_AT)) {
    columnsFirst.splice(2, 0, {
      Header: 'Completed At',
      id: 'completed_at',
      accessor: d => timeStamp(d.completedAt),
    })
  }

  const dropDownOptions = (model) => {
    let options = [];

    options.push({
      onClick: () => handleOnView(model),
      title: 'Details'
    });

    if (isSaleEditable(model.status, model.paymentType, model.paymentId)) {
      options.push({
        onClick: () => handleOnEdit(model),
        title: 'Edit'
      });
    }

    if (isSaleDeletable(model.status, model.paymentType)) {
      options.push({
        onClick: () => handleOnDelete(model),
        title: 'Delete'
      });
    }

    return options;
  };

  let columnsActions: any = [
    {
      Cell: (row) => {
        const options = dropDownOptions(row.original);

        return <DropDownButtons options={options} />
      }
    }
  ];

  const columns = columnsFirst.concat(columnAdditional).concat(columnsActions);

  return (
    <PageContentWrapper>
      <Table
        columns={columns}
        {...rest}
      />
    </PageContentWrapper>
  );
};
